import React from 'react';
import cx from 'classnames';
import { VendorTaxonomyKey } from '@zola-helpers/client/dist/es/marketplace/vendorTaxonomyKeys';
import { getVendorIconV3 } from '../../util/getVendorIconV3';

import styles from './vendorCircleIcon.module.less';

export type VendorCircleIconProps = React.HTMLAttributes<HTMLDivElement> & {
  taxonomyKey: VendorTaxonomyKey;
  size?: number;
};

export const VendorCircleIcon = ({
  taxonomyKey,
  size = 64,
  className,
  ...rest
}: VendorCircleIconProps) => {
  const style = { width: `${size}px`, height: `${size}px` };
  const Icon = getVendorIconV3(taxonomyKey);
  const iconSize = size / 2;
  return (
    <div className={cx(styles.vendorCircleIcon, className)} style={style} {...rest}>
      <Icon width={iconSize} height={iconSize} />
    </div>
  );
};

export default VendorCircleIcon;
